import { Flex, Divider, Card, Text, Heading } from '@applyboard/crystal-ui';
import { useApplication } from '~/context';

type AttributesViewProps = { items: Array<{ label: string; value: string }>; line: string };

function AttributesView(props: Readonly<AttributesViewProps>) {
  return (
    <Flex gap={1} align="end" direction="row" id={`program-line-${props.line}`}>
      {props.items.map((item, idx) => (
        <Flex key={item.label} gap={3} direction="row" pr={2}>
          <Flex direction="row" gap={1} aria-describedby={item.label}>
            <Text id={item.label} variant="labelM">
              {item.label}
            </Text>
            <Text variant="bodyM" aria-labelledby={item.label}>
              {item.value}
            </Text>
          </Flex>
          {idx !== props.items.length - 1 && <Divider direction="vertical" />}
        </Flex>
      ))}
    </Flex>
  );
}

type ProgramDetailsProps = { lineSplit: boolean };
export function ProgramDetails(props: Readonly<ProgramDetailsProps>) {
  const { application } = useApplication();
  const { program, campus, intakeTerm } = application.programIntake;
  const items = [
    { label: 'Program Name', value: program.name },
    { label: 'Campus', value: campus.name },
    { label: 'Start', value: intakeTerm.name },
  ];
  let split = items.length;
  if (props.lineSplit) {
    split = 3;
  }
  return (
    <Card emphasis="highlighted">
      <Flex direction="column">
        <Flex gap={3} align="center">
          <Heading level={2}>Current Primary Program</Heading>
        </Flex>
        <Divider direction="horizontal" />
        <AttributesView items={items.slice(0, split)} line="1" />
        {props.lineSplit && <AttributesView items={items.slice(split, items.length)} line="2" />}
      </Flex>
    </Card>
  );
}
